import { jsx as _jsx } from "react/jsx-runtime";
import { useFirstOrderIncentiveFormattedData } from "@faire/retailer-visitor-shared/hooks/firstOrderIncentive/useFirstOrderIncentiveFormattedData";
import { useFirstOrderIncentiveStore } from "@faire/retailer-visitor-shared/hooks/firstOrderIncentive/useFirstOrderIncentiveStore";
import { useFirstOrderIncentiveTimeRemaining } from "@faire/retailer-visitor-shared/hooks/firstOrderIncentive/useFirstOrderIncentiveTimeRemaining";
import { MediumFormatting } from "@faire/web--source/common/localization/formatting";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
export var useAutoExtendText = function() {
    var _useFirstOrderIncentiveStore = useFirstOrderIncentiveStore(), formattedIncentiveData = _useFirstOrderIncentiveStore.formattedIncentiveData, isMaximalistFoi = _useFirstOrderIncentiveStore.isMaximalistFoi, isFirstOrderForFaireDirectIncentive = _useFirstOrderIncentiveStore.isFirstOrderForFaireDirectIncentive;
    var expiresAt = formattedIncentiveData.expiresAt;
    var _useFirstOrderIncentiveTimeRemaining = useFirstOrderIncentiveTimeRemaining(expiresAt !== null && expiresAt !== void 0 ? expiresAt : 0), daysRemainingNumber = _useFirstOrderIncentiveTimeRemaining.daysRemaining, hoursRemaining = _useFirstOrderIncentiveTimeRemaining.hoursRemaining;
    var formattedIncentivePercent = useFirstOrderIncentiveFormattedData().formattedIncentivePercent;
    var autoExtendLessThan24HoursText = function() {
        if (isFirstOrderForFaireDirectIncentive) {
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "x+/OFF",
                defaultMessage: [
                    {
                        type: 6,
                        value: "hoursRemainingNumber",
                        options: {
                            one: {
                                value: [
                                    {
                                        type: 8,
                                        value: "MediumFormatting",
                                        children: [
                                            {
                                                type: 7
                                            },
                                            {
                                                type: 0,
                                                value: " hour left"
                                            }
                                        ]
                                    },
                                    {
                                        type: 0,
                                        value: " to get "
                                    },
                                    {
                                        type: 1,
                                        value: "percentNumber"
                                    },
                                    {
                                        type: 0,
                                        value: " off your first order with any brand."
                                    }
                                ]
                            },
                            other: {
                                value: [
                                    {
                                        type: 8,
                                        value: "MediumFormatting",
                                        children: [
                                            {
                                                type: 7
                                            },
                                            {
                                                type: 0,
                                                value: " hours left"
                                            }
                                        ]
                                    },
                                    {
                                        type: 0,
                                        value: " to get "
                                    },
                                    {
                                        type: 1,
                                        value: "percentNumber"
                                    },
                                    {
                                        type: 0,
                                        value: " off your first order with any brand."
                                    }
                                ]
                            }
                        },
                        offset: 0,
                        pluralType: "cardinal"
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    // Round up to 1 so we don't show "0 hours remaining"
                    hoursRemainingNumber: hoursRemaining || 1,
                    percentNumber: formattedIncentivePercent
                }
            });
        }
        if (isMaximalistFoi) {
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "rf5Ivg",
                defaultMessage: [
                    {
                        type: 6,
                        value: "hoursRemainingNumber",
                        options: {
                            one: {
                                value: [
                                    {
                                        type: 8,
                                        value: "MediumFormatting",
                                        children: [
                                            {
                                                type: 7
                                            },
                                            {
                                                type: 0,
                                                value: " hour left"
                                            }
                                        ]
                                    },
                                    {
                                        type: 0,
                                        value: " to get "
                                    },
                                    {
                                        type: 1,
                                        value: "percentNumber"
                                    },
                                    {
                                        type: 0,
                                        value: " off and free shipping on your first order."
                                    }
                                ]
                            },
                            other: {
                                value: [
                                    {
                                        type: 8,
                                        value: "MediumFormatting",
                                        children: [
                                            {
                                                type: 7
                                            },
                                            {
                                                type: 0,
                                                value: " hours left"
                                            }
                                        ]
                                    },
                                    {
                                        type: 0,
                                        value: " to get "
                                    },
                                    {
                                        type: 1,
                                        value: "percentNumber"
                                    },
                                    {
                                        type: 0,
                                        value: " off and free shipping on your first order."
                                    }
                                ]
                            }
                        },
                        offset: 0,
                        pluralType: "cardinal"
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    // Round up to 1 so we don't show "0 hours remaining"
                    hoursRemainingNumber: hoursRemaining || 1,
                    percentNumber: formattedIncentivePercent
                }
            });
        }
        return /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "NIYcBM",
            defaultMessage: [
                {
                    type: 6,
                    value: "hoursRemainingNumber",
                    options: {
                        one: {
                            value: [
                                {
                                    type: 8,
                                    value: "MediumFormatting",
                                    children: [
                                        {
                                            type: 7
                                        },
                                        {
                                            type: 0,
                                            value: " hour left"
                                        }
                                    ]
                                },
                                {
                                    type: 0,
                                    value: " to get "
                                },
                                {
                                    type: 1,
                                    value: "percentNumber"
                                },
                                {
                                    type: 0,
                                    value: " off your first order."
                                }
                            ]
                        },
                        other: {
                            value: [
                                {
                                    type: 8,
                                    value: "MediumFormatting",
                                    children: [
                                        {
                                            type: 7
                                        },
                                        {
                                            type: 0,
                                            value: " hours left"
                                        }
                                    ]
                                },
                                {
                                    type: 0,
                                    value: " to get "
                                },
                                {
                                    type: 1,
                                    value: "percentNumber"
                                },
                                {
                                    type: 0,
                                    value: " off your first order."
                                }
                            ]
                        }
                    },
                    offset: 0,
                    pluralType: "cardinal"
                }
            ],
            values: {
                MediumFormatting: MediumFormatting,
                // Round up to 1 so we don't show "0 hours remaining"
                hoursRemainingNumber: hoursRemaining || 1,
                percentNumber: formattedIncentivePercent
            }
        });
    };
    var defaultAutoExtendText = function() {
        if (isFirstOrderForFaireDirectIncentive) {
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "n2GVk3",
                defaultMessage: [
                    {
                        type: 6,
                        value: "daysRemainingNumber",
                        options: {
                            one: {
                                value: [
                                    {
                                        type: 8,
                                        value: "MediumFormatting",
                                        children: [
                                            {
                                                type: 7
                                            },
                                            {
                                                type: 0,
                                                value: " day left"
                                            }
                                        ]
                                    },
                                    {
                                        type: 0,
                                        value: " to get "
                                    },
                                    {
                                        type: 1,
                                        value: "percentNumber"
                                    },
                                    {
                                        type: 0,
                                        value: " off your first order with any brand."
                                    }
                                ]
                            },
                            other: {
                                value: [
                                    {
                                        type: 8,
                                        value: "MediumFormatting",
                                        children: [
                                            {
                                                type: 7
                                            },
                                            {
                                                type: 0,
                                                value: " days left"
                                            }
                                        ]
                                    },
                                    {
                                        type: 0,
                                        value: " to get "
                                    },
                                    {
                                        type: 1,
                                        value: "percentNumber"
                                    },
                                    {
                                        type: 0,
                                        value: " off your first order with any brand."
                                    }
                                ]
                            }
                        },
                        offset: 0,
                        pluralType: "cardinal"
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    daysRemainingNumber: daysRemainingNumber,
                    percentNumber: formattedIncentivePercent
                }
            });
        }
        if (isMaximalistFoi) {
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "eTs/Nd",
                defaultMessage: [
                    {
                        type: 6,
                        value: "daysRemainingNumber",
                        options: {
                            one: {
                                value: [
                                    {
                                        type: 8,
                                        value: "MediumFormatting",
                                        children: [
                                            {
                                                type: 7
                                            },
                                            {
                                                type: 0,
                                                value: " day left"
                                            }
                                        ]
                                    },
                                    {
                                        type: 0,
                                        value: " to get "
                                    },
                                    {
                                        type: 1,
                                        value: "percentNumber"
                                    },
                                    {
                                        type: 0,
                                        value: " off and free shipping on your first order."
                                    }
                                ]
                            },
                            other: {
                                value: [
                                    {
                                        type: 8,
                                        value: "MediumFormatting",
                                        children: [
                                            {
                                                type: 7
                                            },
                                            {
                                                type: 0,
                                                value: " days left"
                                            }
                                        ]
                                    },
                                    {
                                        type: 0,
                                        value: " to get "
                                    },
                                    {
                                        type: 1,
                                        value: "percentNumber"
                                    },
                                    {
                                        type: 0,
                                        value: " off and free shipping on your first order."
                                    }
                                ]
                            }
                        },
                        offset: 0,
                        pluralType: "cardinal"
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    daysRemainingNumber: daysRemainingNumber,
                    percentNumber: formattedIncentivePercent
                }
            });
        }
        return /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "deaXYz",
            defaultMessage: [
                {
                    type: 6,
                    value: "daysRemainingNumber",
                    options: {
                        one: {
                            value: [
                                {
                                    type: 8,
                                    value: "MediumFormatting",
                                    children: [
                                        {
                                            type: 7
                                        },
                                        {
                                            type: 0,
                                            value: " day left"
                                        }
                                    ]
                                },
                                {
                                    type: 0,
                                    value: " to get "
                                },
                                {
                                    type: 1,
                                    value: "percentNumber"
                                },
                                {
                                    type: 0,
                                    value: " off your first order."
                                }
                            ]
                        },
                        other: {
                            value: [
                                {
                                    type: 8,
                                    value: "MediumFormatting",
                                    children: [
                                        {
                                            type: 7
                                        },
                                        {
                                            type: 0,
                                            value: " days left"
                                        }
                                    ]
                                },
                                {
                                    type: 0,
                                    value: " to get "
                                },
                                {
                                    type: 1,
                                    value: "percentNumber"
                                },
                                {
                                    type: 0,
                                    value: " off your first order."
                                }
                            ]
                        }
                    },
                    offset: 0,
                    pluralType: "cardinal"
                }
            ],
            values: {
                MediumFormatting: MediumFormatting,
                daysRemainingNumber: daysRemainingNumber,
                percentNumber: formattedIncentivePercent
            }
        });
    };
    var autoExtendText = function() {
        switch(true){
            case hoursRemaining < 24:
                return autoExtendLessThan24HoursText();
            default:
                return defaultAutoExtendText();
        }
    };
    return autoExtendText();
};
